import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box, Typography, Button, TextField, Select, MenuItem,
  FormControl, RadioGroup, FormControlLabel, Radio
} from '@mui/material';

const PLANETS = ['Sun', 'Moon', 'Mercury', 'Venus', 'Mars', 'Jupiter', 'Saturn', 'Uranus', 'Neptune', 'Pluto', 'Rahu', 'Ketu'];
const SIGNS = ['Aries', 'Taurus', 'Gemini', 'Cancer', 'Leo', 'Virgo', 'Libra', 'Scorpio', 'Sagittarius', 'Capricorn', 'Aquarius', 'Pisces'];
const NAKSHATRAS = [
  'Ashwini', 'Bharani', 'Krittika', 'Rohini', 'Mrigashira', 'Ardra', 'Punarvasu',
  'Pushya', 'Ashlesha', 'Magha', 'Purva Phalguni', 'Uttara Phalguni', 'Hasta',
  'Chitra', 'Swati', 'Vishakha', 'Anuradha', 'Jyeshtha', 'Mula', 'Purva Ashadha',
  'Uttara Ashadha', 'Shravana', 'Dhanishta', 'Shatabhisha', 'Purva Bhadrapada',
  'Uttara Bhadrapada', 'Revati'
];


const initForms = {
  r1:  { planet1: 'Sun', planet2: 'Moon', numSigns: '1',          value: '2' },
  r2:  { planet1: 'Sun', planet2: 'Moon', numSigns: '1',          value: '2' },
  r3:  { planet1: 'Sun', planet2: 'Moon', numNakshatra: '1',      value: '2' },
  r4:  { planet1: 'Sun', planet2: 'Moon', aspectType: 'all',      value: '2' },
  r5:  { planet: 'Sun',  sign: 'Aries',   aspectType: 'all',      value: '2' },
  r6:  { planet: 'Sun',  sign: 'Aries',   value: '2' },
  r7:  { planet: 'Sun',  nakshatra: 'Ashwini', value: '2' },
  r8:  { planet1: 'Sun', planet2: 'Moon', planet3: 'Mars', tolerance: '2', value: '2' },
  r9:  { planet: 'Sun',                                           value: '2' },
  r10: { planet: 'Sun',                                           value: '2' },
  r11: { planet1: 'Sun', planet2: 'Moon', aspectDeg: '0', value: '2' },
  r12: { planet1: 'Sun', planet2: 'Moon', aspectDeg: '0', sign: 'Aries', value: '2' },
};

/* ── helpers ── */
const PlanetSel = ({ value, onChange, exclude }) => (
  <FormControl size="small" sx={{ minWidth: 110 }}>
    <Select value={value} onChange={e => onChange(e.target.value)}>
      {PLANETS.filter(p => !exclude || !exclude.includes(p)).map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}
    </Select>
  </FormControl>
);
PlanetSel.propTypes = { value: PropTypes.string.isRequired, onChange: PropTypes.func.isRequired, exclude: PropTypes.array };

const SignSel = ({ value, onChange }) => (
  <FormControl size="small" sx={{ minWidth: 120 }}>
    <Select value={value} onChange={e => onChange(e.target.value)}>
      {SIGNS.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
    </Select>
  </FormControl>
);
SignSel.propTypes = { value: PropTypes.string.isRequired, onChange: PropTypes.func.isRequired };

const NakshSel = ({ value, onChange }) => (
  <FormControl size="small" sx={{ minWidth: 150 }}>
    <Select value={value} onChange={e => onChange(e.target.value)}>
      {NAKSHATRAS.map(n => <MenuItem key={n} value={n}>{n}</MenuItem>)}
    </Select>
  </FormControl>
);
NakshSel.propTypes = { value: PropTypes.string.isRequired, onChange: PropTypes.func.isRequired };

const Lbl = ({ children }) => (
  <Typography sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>{children}</Typography>
);
Lbl.propTypes = { children: PropTypes.node.isRequired };

const Num = ({ value, onChange, width }) => (
  <TextField size="small" type="number" value={value} onChange={e => onChange(e.target.value)} sx={{ width: width || 70 }} />
);
Num.propTypes = { value: PropTypes.string.isRequired, onChange: PropTypes.func.isRequired, width: PropTypes.number };

const ValField = ({ value, onChange }) => (
  <TextField size="small" type="number" value={value} onChange={e => onChange(e.target.value)}
    inputProps={{ min: 1, step: 1 }} sx={{ width: 56 }} />
);
ValField.propTypes = { value: PropTypes.string.isRequired, onChange: PropTypes.func.isRequired };

const AddBtn = ({ onClick, disabled }) => (
  <Button variant="contained" size="small" onClick={onClick} disabled={disabled}
    sx={{ minWidth: 56, px: 1.5, backgroundColor: '#1976d2', '&:hover': { backgroundColor: '#1565c0' } }}>
    ADD
  </Button>
);
AddBtn.propTypes = { onClick: PropTypes.func.isRequired, disabled: PropTypes.bool };

const AspectDegField = ({ value, onChange }) => (
  <TextField size="small" type="number" value={value}
    onChange={e => {
      const v = parseFloat(e.target.value);
      if (e.target.value === '') { onChange(''); return; }
      if (!isNaN(v)) onChange(String(Math.min(180, Math.max(0, v))));
    }}
    inputProps={{ min: 0, max: 180, step: 0.01 }} sx={{ width: 80 }} />
);
AspectDegField.propTypes = { value: PropTypes.string.isRequired, onChange: PropTypes.func.isRequired };

const AspectRadio = ({ value, onChange }) => (
  <RadioGroup row value={value} onChange={e => onChange(e.target.value)}
    sx={{ flexWrap: 'nowrap' }}>
    <FormControlLabel value="all" control={<Radio size="small" />} label={<Typography sx={{ fontSize: '0.95rem' }}>All Aspects</Typography>} />
    <FormControlLabel value="7th" control={<Radio size="small" />} label={<Typography sx={{ fontSize: '0.95rem' }}>Only 7th aspect</Typography>} />
  </RadioGroup>
);
AspectRadio.propTypes = { value: PropTypes.string.isRequired, onChange: PropTypes.func.isRequired };

const Row = ({ children }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1,
    border: '1px solid #d0d0d0', borderRadius: 1, p: 1, mb: 1, backgroundColor: '#fafafa' }}>
    {children}
  </Box>
);
Row.propTypes = { children: PropTypes.node.isRequired };

const Spacer = () => <Box sx={{ flex: 1 }} />;

const AddTail = ({ value, onChange, onClick, disabled }) => (
  <>
    <Lbl>Add value</Lbl>
    <ValField value={value} onChange={onChange} />
    <AddBtn onClick={onClick} disabled={disabled} />
  </>
);
AddTail.propTypes = { value: PropTypes.string.isRequired, onChange: PropTypes.func.isRequired, onClick: PropTypes.func.isRequired, disabled: PropTypes.bool };

/* ─────────────────────────── main ─────────────────────────── */
const MOAGroup6Tab = ({ onAddCondition, forms: propForms, onFormsChange }) => {
  const [localForms, setLocalForms] = useState(initForms);
  const forms = propForms || localForms;
  const setForms = onFormsChange || setLocalForms;
  const set = (row, field, val) => setForms(f => ({ ...f, [row]: { ...f[row], [field]: val } }));
  const setPair = (row, f1, v, f2) => setForms(prev => {
    const updated = { ...prev[row], [f1]: v };
    if (updated[f2] === v) updated[f2] = PLANETS.find(p => p !== v) || PLANETS[0];
    return { ...prev, [row]: updated };
  });
  const setTriple = (row, f1, v, f2, f3) => setForms(prev => {
    const updated = { ...prev[row], [f1]: v };
    const taken = new Set([v]);
    [f2, f3].forEach(of => {
      if (taken.has(updated[of])) {
        const next = PLANETS.find(p => !taken.has(p));
        updated[of] = next || PLANETS[0];
      }
      taken.add(updated[of]);
    });
    return { ...prev, [row]: updated };
  });

  const add = (type, condObj) => {
    const val = parseInt(condObj.value, 10);
    if (!val || val < 1) return;
    onAddCondition({ group: 6, type, ...condObj, value: val });
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography fontWeight="bold" fontSize={15} sx={{ textAlign: 'center', mb: 2, letterSpacing: 0.5 }}>
        Vedic Criteria
      </Typography>

      {/* Row 1: Planet Follows Planet By Number Of Signs */}
      <Row>
        <Lbl>Planet</Lbl>
        <PlanetSel value={forms.r1.planet1} onChange={v => setPair('r1', 'planet1', v, 'planet2')} exclude={[forms.r1.planet2]} />
        <Lbl>Follows Planet</Lbl>
        <PlanetSel value={forms.r1.planet2} onChange={v => setPair('r1', 'planet2', v, 'planet1')} exclude={[forms.r1.planet1]} />
        <Lbl>By Number Of Signs</Lbl>
        <Num value={forms.r1.numSigns} onChange={v => set('r1', 'numSigns', v)} />
        <Spacer />
        <AddTail value={forms.r1.value} onChange={v => set('r1', 'value', v)}
          onClick={() => add('g6_follows_by_signs', { planet1: forms.r1.planet1, planet2: forms.r1.planet2, numSigns: Number(forms.r1.numSigns), value: forms.r1.value })} />
      </Row>

      {/* Row 2: Planet And Planet are apart By Number Of Signs */}
      <Row>
        <Lbl>Planet</Lbl>
        <PlanetSel value={forms.r2.planet1} onChange={v => setPair('r2', 'planet1', v, 'planet2')} exclude={[forms.r2.planet2]} />
        <Lbl>And Planet</Lbl>
        <PlanetSel value={forms.r2.planet2} onChange={v => setPair('r2', 'planet2', v, 'planet1')} exclude={[forms.r2.planet1]} />
        <Lbl>are apart By Number Of Signs</Lbl>
        <Num value={forms.r2.numSigns} onChange={v => set('r2', 'numSigns', v)} />
        <Spacer />
        <AddTail value={forms.r2.value} onChange={v => set('r2', 'value', v)}
          onClick={() => add('g6_apart_by_signs', { planet1: forms.r2.planet1, planet2: forms.r2.planet2, numSigns: Number(forms.r2.numSigns), value: forms.r2.value })} />
      </Row>

      {/* Row 3: Planet And Planet are apart By Number Of nakshatra */}
      <Row>
        <Lbl>Planet</Lbl>
        <PlanetSel value={forms.r3.planet1} onChange={v => setPair('r3', 'planet1', v, 'planet2')} exclude={[forms.r3.planet2]} />
        <Lbl>And Planet</Lbl>
        <PlanetSel value={forms.r3.planet2} onChange={v => setPair('r3', 'planet2', v, 'planet1')} exclude={[forms.r3.planet1]} />
        <Lbl>are apart By Number Of nakshatra</Lbl>
        <Num value={forms.r3.numNakshatra} onChange={v => set('r3', 'numNakshatra', v)} />
        <Spacer />
        <AddTail value={forms.r3.value} onChange={v => set('r3', 'value', v)}
          onClick={() => add('g6_apart_by_nakshatra', { planet1: forms.r3.planet1, planet2: forms.r3.planet2, numNakshatra: Number(forms.r3.numNakshatra), value: forms.r3.value })} />
      </Row>

      {/* Row 4: Planet aspected by Planet [All Aspects / Only 7th aspect] */}
      <Row>
        <Lbl>Planet</Lbl>
        <PlanetSel value={forms.r4.planet1} onChange={v => setPair('r4', 'planet1', v, 'planet2')} exclude={[forms.r4.planet2]} />
        <Lbl>aspected by Planet</Lbl>
        <PlanetSel value={forms.r4.planet2} onChange={v => setPair('r4', 'planet2', v, 'planet1')} exclude={[forms.r4.planet1]} />
        <AspectRadio value={forms.r4.aspectType} onChange={v => set('r4', 'aspectType', v)} />
        <Spacer />
        <AddTail value={forms.r4.value} onChange={v => set('r4', 'value', v)}
          onClick={() => add('g6_aspected_by_planet', { planet1: forms.r4.planet1, planet2: forms.r4.planet2, aspectType: forms.r4.aspectType, value: forms.r4.value })} />
      </Row>

      {/* Row 5: Planet Aspecting Sign [All Aspects / Only 7th aspect] */}
      <Row>
        <Lbl>Planet</Lbl>
        <PlanetSel value={forms.r5.planet} onChange={v => set('r5', 'planet', v)} />
        <Lbl>Aspecting Sign</Lbl>
        <SignSel value={forms.r5.sign} onChange={v => set('r5', 'sign', v)} />
        <AspectRadio value={forms.r5.aspectType} onChange={v => set('r5', 'aspectType', v)} />
        <Spacer />
        <AddTail value={forms.r5.value} onChange={v => set('r5', 'value', v)}
          onClick={() => add('g6_aspecting_sign', { planet: forms.r5.planet, sign: forms.r5.sign, aspectType: forms.r5.aspectType, value: forms.r5.value })} />
      </Row>

      {/* Row 6: Planet In Sign And Planet In Sign */}
      <Row>
        <Lbl>Planet</Lbl>
        <PlanetSel value={forms.r6.planet} onChange={v => set('r6', 'planet', v)} />
        <Lbl>In Sign</Lbl>
        <SignSel value={forms.r6.sign} onChange={v => set('r6', 'sign', v)} />
        <Spacer />
        <AddTail value={forms.r6.value} onChange={v => set('r6', 'value', v)}
          onClick={() => add('g6_planet_in_sign', { planet: forms.r6.planet, sign: forms.r6.sign, value: forms.r6.value })} />
      </Row>

      {/* Row 7: Planet In Nakshatra And Planet In Nakshatra */}
      <Row>
        <Lbl>Planet</Lbl>
        <PlanetSel value={forms.r7.planet} onChange={v => set('r7', 'planet', v)} />
        <Lbl>In Nakshatra</Lbl>
        <NakshSel value={forms.r7.nakshatra} onChange={v => set('r7', 'nakshatra', v)} />
        <Spacer />
        <AddTail value={forms.r7.value} onChange={v => set('r7', 'value', v)}
          onClick={() => add('g6_planet_in_nakshatra', { planet: forms.r7.planet, nakshatra: forms.r7.nakshatra, value: forms.r7.value })} />
      </Row>

      {/* Row 8: Planet Midpoint between Planet And Planet Tolerance degrees */}
      <Row>
        <Lbl>Planet</Lbl>
        <PlanetSel value={forms.r8.planet1} onChange={v => setTriple('r8', 'planet1', v, 'planet2', 'planet3')} exclude={[forms.r8.planet2, forms.r8.planet3]} />
        <Lbl>Midpoint between Planet</Lbl>
        <PlanetSel value={forms.r8.planet2} onChange={v => setTriple('r8', 'planet2', v, 'planet1', 'planet3')} exclude={[forms.r8.planet1, forms.r8.planet3]} />
        <Lbl>And Planet</Lbl>
        <PlanetSel value={forms.r8.planet3} onChange={v => setTriple('r8', 'planet3', v, 'planet1', 'planet2')} exclude={[forms.r8.planet1, forms.r8.planet2]} />
        <Lbl>Tolerance degrees</Lbl>
        <Num value={forms.r8.tolerance} onChange={v => set('r8', 'tolerance', v)} />
        <Spacer />
        <AddTail value={forms.r8.value} onChange={v => set('r8', 'value', v)}
          onClick={() => add('g6_midpoint', { planet1: forms.r8.planet1, planet2: forms.r8.planet2, planet3: forms.r8.planet3, tolerance: Number(forms.r8.tolerance), value: forms.r8.value })} />
      </Row>

      {/* Row 11: Planet And Planet aspect [dropdown] */}
      <Row>
        <Lbl>Planet</Lbl>
        <PlanetSel value={forms.r11.planet1} onChange={v => setPair('r11', 'planet1', v, 'planet2')} exclude={[forms.r11.planet2]} />
        <Lbl>And Planet</Lbl>
        <PlanetSel value={forms.r11.planet2} onChange={v => setPair('r11', 'planet2', v, 'planet1')} exclude={[forms.r11.planet1]} />
        <Lbl>aspect degrees</Lbl>
        <AspectDegField value={forms.r11.aspectDeg} onChange={v => set('r11', 'aspectDeg', v)} />
        <Spacer />
        <AddTail value={forms.r11.value} onChange={v => set('r11', 'value', v)}
          onClick={() => add('g6_planet_aspect_planet', { planet1: forms.r11.planet1, planet2: forms.r11.planet2, aspectDeg: Number(forms.r11.aspectDeg), value: forms.r11.value })} />
      </Row>

      {/* Row 12: Planet And Planet aspect [dropdown] in sign [dropdown] */}
      <Row>
        <Lbl>Planet</Lbl>
        <PlanetSel value={forms.r12.planet1} onChange={v => setPair('r12', 'planet1', v, 'planet2')} exclude={[forms.r12.planet2]} />
        <Lbl>And Planet</Lbl>
        <PlanetSel value={forms.r12.planet2} onChange={v => setPair('r12', 'planet2', v, 'planet1')} exclude={[forms.r12.planet1]} />
        <Lbl>aspect degrees</Lbl>
        <AspectDegField value={forms.r12.aspectDeg} onChange={v => set('r12', 'aspectDeg', v)} />
        <Lbl>in sign</Lbl>
        <SignSel value={forms.r12.sign} onChange={v => set('r12', 'sign', v)} />
        <Spacer />
        <AddTail value={forms.r12.value} onChange={v => set('r12', 'value', v)}
          onClick={() => add('g6_planet_aspect_planet_in_sign', { planet1: forms.r12.planet1, planet2: forms.r12.planet2, aspectDeg: Number(forms.r12.aspectDeg), sign: forms.r12.sign, value: forms.r12.value })} />
      </Row>

    </Box>
  );
};

MOAGroup6Tab.propTypes = {
  onAddCondition: PropTypes.func.isRequired,
  forms: PropTypes.object,
  onFormsChange: PropTypes.func,
};

export default MOAGroup6Tab;
